import React, { Component } from 'react';
import { withRouter } from 'react-router';
import PropTypes from 'prop-types';
import ArrowIcon from '../Svg/ArrowIcon';
import './Back.css';
import CallMeBackBtn from '../../Common/CallMeBackBtn/CallMeBackBtn';
import SquareWhatsapp from '../WhatsappBtn/SquareWhatsApp';


class Back extends Component {

	static propTypes = {
		automationidattr: PropTypes.string,
		backUrl: PropTypes.string,
		buttonName: PropTypes.string,
		enabledButton: PropTypes.bool,
		gotoCms: PropTypes.any,
		nextUrl: PropTypes.string,
		onNextClick: PropTypes.func,
		page: PropTypes.string,
		submitClick: PropTypes.func,
		totalMonthlyCost: PropTypes.any,
	}
	
  miniAppProactiveSalesFlag = false;

	constructor(props) {
		super(props);

		const miniAppProactiveSales = sessionStorage.getItem('ftthMA');
    this.miniAppProactiveSalesFlag = !!(miniAppProactiveSales && miniAppProactiveSales.toUpperCase() === 'TRUE');
	}

	backButtonClickHandler = () => {
		if (this.props.gotoCms) {
			window.location.href = '/vodacom/fibre/sales/leads';
		} else {
			window.scrollTo(0, 0);
			if (this.props.backUrl) {
				this.props.history.push(this.props.backUrl);
			} else {
				this.props.history.goBack();
			}
		}
	}

	submitClickHandler = () => {
		window.scrollTo(0, 0);
		this.props.submitClick && this.props.submitClick();
		this.props.history.push(this.props.nextUrl);
	}

	render() {
		return (
			<div>
				<div className="desktop-back-container">
					<div className="desktop-back-button-wrapper">
						<div className="back-arrow-icon">
							<ArrowIcon direction={'icon-chevron-left'} />
						</div>
						<button
							className="back-button"
							onClick={this.backButtonClickHandler}
							automationid={`SalesLead_Button_${this.props.automationidattr}Back_0`}
						>
							BACK
						</button>
					</div>
					<div className="price-and-checkout-section">
						<div className="total-cost-container">
							{ this.props.totalMonthlyCost
								? <div className="total-monthly-cost-container">
										<div className="price-label"
											automationid={`SalesLead_Div_${this.props.automationidattr}MonthlyCostLabel_0`}>
											Total Monthly cost
										</div>
										<div className="total-price"
											automationid={`SalesLead_Div_${this.props.automationidattr}MonthlyCostPrice_0`}>
											R{this.props.totalMonthlyCost}PM
										</div>
									</div>
								: null
							}

						</div>

						{ this.props.buttonName
							? <div className="back-item">
									{ this.props.page
										? <div className='back-item-btn-container'>
												<CallMeBackBtn page={this.props.page} />
												<SquareWhatsapp/>
											</div>
										: null
									}

									<button
										className={`${this.props.enabledButton ? 'submit-order-red-button' : 'submit-order-grey-button'}`}
										disabled={!this.props.enabledButton}
										onClick={this.props.onNextClick ? this.props.onNextClick : this.submitClickHandler}
										automationid={`SalesLead_Button_${this.props.automationidattr}${this.props.buttonName}_0`}
									><div className='back-item-checkout-btn'>{this.props.buttonName}</div></button>
								</div>
							: null
						}
					</div>

				</div>
				<div className="mobile-back-container" style={this.miniAppProactiveSalesFlag ? { top: 0 } : null }>
					<div className="back-button-wrapper">
						<div className="back-arrow-icon">
							<ArrowIcon
								direction={'icon-chevron-left'}
								automationid={`SalesLead_Div_${this.props.automationidattr}MobileBackIcon_0`}
							/>
						</div>
						<button
							className="back-button"
							onClick={this.backButtonClickHandler}
							automationid={`SalesLead_Button_${this.props.automationidattr}MobileBack_0`}
						>
							BACK
						</button>
					</div>
				</div>
			</div>
		);
	}
}

export default withRouter(Back);